import { formTypes } from '../../../form/form.constants';
import { ComplianceForm } from './compliance-form.model';
import {YearsInSpreadsheet} from '../../../entertainment/models/digital/yearsInSpreadsheet.model';
import {ApprAsset} from './appr-asset.model';

export class AnnualProjectPropertyReport extends ComplianceForm {
  year: string;
  projectStatus: string;

  isProjectFinalPhase?: boolean;
  isProjectFinalPhaseNoDescription: string;
  isProjectFinalPhaseEndOfConstruction?: Date;
  isProjectFinalPhaseBeginningOfOperations?: Date;

  isPropertyPlacedInServiceThisYear?: boolean;

  understandExemptionPeriodProperty?: boolean;
  isProjectRehabRestorationProjectTotaling?: boolean;
  isSubmissionAmendment?: boolean;
  submissionAmendmentDescription: string;

  isAllReportedPropertyPlannedScope?: boolean;
  isAllReportedPropertyPlannedScopeDescription: string;

  hasExcludedNonPermanentProperty?: boolean;
  hasExcludedNonPermanentPropertyDescription: string;

  hasExcludedEnvCapitalUpgrades?: boolean;
  hasExcludedEnvCapitalUpgradesDescription: string;

  hasExcludedMaintenanceCapital?: boolean;
  hasExcludedMaintenanceCapitalDescription: string;

  hasExcludedMiscCapitalAdditions?: boolean;
  hasExcludedMiscCapitalAdditionsDescription: string;

  hasExcludedReplacementParts?: boolean;
  hasExcludedReplacementPartsDescription: string;

  hasTriedToUseLouisianaVendors?: boolean;
  understandPropertyDisposedRequireAmendment?: boolean;
  understandApprAudit?: boolean;

  assets: ApprAsset[];


  constructor(formIndex: number = null) {
    super(formIndex);
    this.init();
  }

  init() {
    super.init();
    this.type = formTypes.appr.abbrev;
  }

  get qualifier() {
    return '';
  }
}
